import { render, staticRenderFns } from "./newPwd.vue?vue&type=template&id=5a801588&"
import script from "./newPwd.vue?vue&type=script&lang=js&"
export * from "./newPwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports